import hasOwn from './hasOwn';

// Borrowed from react-redux,
export function createShallowEqual(
  comparator: (valA: unknown, valB: unknown) => boolean,
) {
  return function shallowEqual(objA: object, objB: object): boolean {
    if (comparator(objA, objB)) {
      return true;
    }

    if (
      objA === null ||
      typeof objA !== 'object' ||
      objB === null ||
      typeof objB !== 'object'
    ) {
      return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    }

    for (const key of keysA) {
      if (
        !hasOwn(objB, key) ||
        !hasOwn(objA, key) ||
        !comparator(objA[key], objB[key])
      ) {
        return false;
      }
    }

    return true;
  };
}

const shallowEqual = createShallowEqual(Object.is);

export default shallowEqual;
